export const Svg_129 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M32.666 61.25H19.032c-1.167 0-2.188-.438-3.062-1.313-.875-.874-1.313-1.895-1.313-3.062V15.312h-3.135v-4.374H25.3V8.75h18.084v2.188h13.782v4.374H54.03V29.24c-.68-.195-1.41-.365-2.187-.51a19.411 19.411 0 0 0-2.188-.293V15.313H19.031v41.563h11.448c.194.535.51 1.24.948 2.115.437.875.85 1.628 1.24 2.26ZM26.25 50.604h2.187c0-3.791.365-6.587 1.094-8.385l1.094-2.698V21.51H26.25v29.093ZM38.135 31.5a14.062 14.062 0 0 1 2.115-1.13c.826-.365 1.58-.669 2.26-.912V21.51h-4.375v9.99Zm10.572 32.74c-4.277 0-7.91-1.508-10.9-4.522-2.99-3.015-4.484-6.66-4.484-10.938 0-4.277 1.5-7.91 4.5-10.9s6.629-4.484 10.885-4.484c4.277 0 7.922 1.5 10.937 4.5 3.014 3 4.521 6.629 4.521 10.885 0 4.277-1.507 7.923-4.521 10.937-3.015 3.014-6.66 4.522-10.938 4.522Zm4.74-8.532 2.042-2.041-5.395-5.396v-8.167h-2.917v9.334l6.27 6.27Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={23.695}
        x2={50.65}
        y1={17.073}
        y2={58.462}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)